import React from 'react';
import Creatable from 'react-select/creatable';
import { pluralText } from '../../utilities/wordUtilities';
import CategoryAndFolderSelector from './CategoryAndFolderSelector';

const getCategory = (selectedCategoryId, isNewCategory) => {
    if (isNewCategory) {
        return ({
            label: selectedCategoryId,
            value: selectedCategoryId,
        });
    }
    const { id: value, name: label } = window.categoriesAndFoldersMap[selectedCategoryId];

    return ({ label, value });
};

const getFolder = (selectedCategoryId, selectedFolderId, isNewFolder) => {
    if (!selectedCategoryId || isNaN(selectedCategoryId) || !selectedFolderId) return null;
    if (isNewFolder) {
        return ({
            label: selectedFolderId,
            value: selectedFolderId,
        });
    }
    const { id: value, name: label } = window.categoriesAndFoldersMap[selectedCategoryId].folders[selectedFolderId];

    return ({ label, value });
};

class MovePagesAndFolderModal extends React.Component {
    state = {
        buttonDisabled: false,
        selectedCategoryId: this.props.categoryId,
        selectedFolderId: this.props.subcategoryId || null,
    };

    handleMove = () => {
        const { selectedCategoryId, selectedFolderId, buttonDisabled } = this.state;
        const { foldersCount } = this.props;

        const isNewCategory = isNaN(selectedCategoryId);
        const category = getCategory(selectedCategoryId, isNewCategory);

        const isNewFolder = !isNaN(selectedCategoryId) && isNaN(selectedFolderId);
        const folder = getFolder(selectedCategoryId, selectedFolderId, isNewFolder);

        // note: this is only for folder moving no-ops; could add a better check here.
        // requires tracking the number of unique "parents", checking if that is 1, and then
        // checking if that parent is equivalent to the selected category/folder.
        if (foldersCount > 0 && !isNewCategory) {
            const folderValue = folder ? folder.value : null;
            if (category.value === this.props.categoryId && folderValue === this.props.subcategoryId) {
                this.props.closeModal();
                return;
            }
        }

        if (!buttonDisabled && isNewCategory) {
            this.props.handleMoveToNewCategory(category);
            this.setState({ buttonDisabled: true });
        } else if (!buttonDisabled && isNewFolder) {
            this.props.handleMoveToNewFolder(category, folder);
            this.setState({ buttonDisabled: true });
        } else if (!buttonDisabled) {
            this.props.handleMove(category, folder);
            this.setState({ buttonDisabled: true });
        }
    };

    render() {
        const { buttonDisabled } = this.state;
        const {
            pagesCount, foldersCount, suggestionsCount, externalResourcesCount, questionsCount, documentsCount, selectedFolders, selectedPages,
        } = this.props;
        const itemsCount = pagesCount + suggestionsCount + externalResourcesCount + questionsCount + documentsCount;
        const informationText = itemsCount && foldersCount
            ? `${pluralText(itemsCount, 'item')} and ${pluralText(foldersCount, 'subcategory')}`
            : itemsCount
                ? `${pluralText(itemsCount, 'item')}`
                : `${pluralText(foldersCount, 'subcategory')}`;
        const subcategoryText = foldersCount ? 'with all contained items' : '';
        const buttonText = buttonDisabled ? 'Moving...' : 'Move';
        const buttonClass = buttonDisabled ? 'btn btn-primary is-disabled' : 'btn btn-primary';

        const hideFolders = false;
        const initialFolderId = this.props.subcategoryId || null;

        return (
            <div className="react-modal open">
                <div className="modal-content">
                    <h2>Move</h2>
                    <div className="mt2 mb2 flex italic">
                        Move
                        {' '}
                        {informationText}
                        {' '}
                        {subcategoryText}
                    </div>
                    <div className="mt2 mb2">
                        <CategoryAndFolderSelector
                            initialCategoryId={this.props.categoryId}
                            initialFolderId={initialFolderId}
                            setCategoryId={(selectedCategoryId) => this.setState({ selectedCategoryId })}
                            setFolderId={(selectedFolderId) => this.setState({ selectedFolderId })}
                            hideFolders={hideFolders}
                            allowUncategorize={false}
                            selectedFolders={this.props.selectedFolders}
                        />
                    </div>
                    <div className="right-align">
                        <span className="btn-secondary mr1" onMouseDown={this.props.closeModal}>Close</span>
                        <span className={buttonClass} onMouseDown={this.handleMove}>{buttonText}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default MovePagesAndFolderModal;
